import { createClient } from '@supabase/supabase-js';
import { clearLegacyAuthStorage, getAuthStorageKey, tabAuthStorage } from './services/auth/tabAuthStorage';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!supabaseConfigured) {
  console.error(
    'Supabase is not configured. Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to your .env file, then restart npm start.',
  );
}

if (typeof window !== 'undefined') {
  clearLegacyAuthStorage();
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: tabAuthStorage,
      storageKey: getAuthStorageKey(),
    },
  },
);

export function getSupabaseConfigError() {
  if (supabaseConfigured) return null;
  return 'Supabase is not configured. Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to .env and restart the dev server.';
}

export function formatSupabaseError(error, fallback = 'Database request failed.') {
  if (!error) return fallback;
  const message = error.message || fallback;
  if (error.status === 401 || /401|unauthorized|invalid api key/i.test(message)) {
    return 'Supabase returned 401 Unauthorized. Check your anon key in .env (Project Settings → API → anon public), restart npm start, then run supabase/fix_rls_policies.sql in the SQL Editor.';
  }
  if (/row-level security|permission denied|42501/i.test(message)) {
    return 'Database permission denied (RLS). Run supabase/fix_rls_policies.sql in your Supabase SQL Editor.';
  }
  return message;
}
